import React, { useEffect, useState } from 'react';
import VideoEnvironment from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import LoadedAssetsUI from '../../cvp-webgames-core/Components/general/react/LoadedAssetsUI';
import GameManager from '../../cvp-webgames-core/GameManager';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
var showScoreForCurrentBadge = false;

const debugData = [
	{
		title: 'Best',
		color: 'green'
	},
	{
		title: 'Zero',
		color: 'white'
	},
	{
		title: 'Ok',
		color: 'gold'
	},
	{
		title: 'Worst',
		color: 'red'
	},
	{
		title: 'Worst2',
		color: 'rgb(255, 100, 100)'
	}
]
var isInit = false;
// globals.showDebugForComponents = Tools.isLocalhost();
const DebugUI = (props: DebugUIConfig) => {
	const [enableDebugMenu, setEnableDebugMenu] = useState(globals.showDebugForComponents);

	var startDebugTimeout = () => {
		if(isInit) {
			return;
		}
		isInit = true;
	};

	const getScoreForCurrentScenario = () => {
		var savedData = props.gameManager.customData.saveData;
		var id = parseInt(props.scenarioId[props.scenarioId.length - 1]) - 1;
		var scenario = savedData.scenarios[id];

		var result: {
			key: string,
			current?: number,
			max: number
		}[] = [];

		for(var indx = 0; indx < scenario.badges.length; indx++) {
			result.push({
				key: scenario.badges[indx].key,
				max: scenario.badges[indx].maxPoints,
				current: (scenario as any).scores && (scenario as any).scores.length > indx ? (scenario as any).scores[indx] : 0
			})
		}

		return result;
	}

	useEffect(() => {
		startDebugTimeout();
	})
	return (
		<div className="modal-disable-select" >
			{enableDebugMenu ? (
				<button tabIndex={-1} style={{
					position: 'absolute',
					bottom: '10px',
					left: '10px',
					color: 'white',
					pointerEvents: 'all',
					zIndex: 100
				}} onClick={() => {
					globals.showDebugForComponents = !globals.showDebugForComponents;
					setEnableDebugMenu(globals.showDebugForComponents);
				}}>
					{(globals.showDebugForComponents ? 'Hide' : 'Show') + ' Debug Tools'}
				</button>
			) : (null)}

			{globals.showDebugForComponents ? (
				<button tabIndex={-1} style={{
					position: 'absolute',
					top: '30px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					color: 'white',
					pointerEvents: 'all',
					zIndex: 100
				}} onClick={() => {	
					showScoreForCurrentBadge = !showScoreForCurrentBadge;
					// props.forceUpdate();
				}}>
					{(showScoreForCurrentBadge ? 'Hide ' : 'Show ') + 'Score For Current Badge'}
				</button>
			) : (null)}

			{globals.showDebugForComponents && showScoreForCurrentBadge ? ( 
				<div style={{
					position: 'absolute',
					bottom: '10px',
					right: '10px',
						zIndex: 100
				}}>
					{getScoreForCurrentScenario().map(score => {
						return (<p className="title-font" style={{
							color: 'white'
						}}>{score.key + ': ' + score.current + '/' + score.max }</p>)
					})}
				</div>) : (null)}


			{globals.showDebugForComponents && globals.showDebugAnswerTypes ? (
				<div style={{
					position: 'absolute',
					top: '84px',
					left: '160px',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<div style={{
						position: 'absolute',
						top: '-125ppx',
						width: '100px',
						height: '125px',
						pointerEvents: 'none',
						backgroundColor: 'rgba(0,0,0, 0.5)'
					}}>
						{debugData.map((item) => {
							return (
								<div style={{
									width: '100%',
									height: '25px',
								}}>
									<div style={{
										width: '25px',
										height: '25px',
										backgroundColor: item.color,
										float: 'left'
									}}>
									</div>
									<p style={{
										float: 'right',
										margin: 0
									}}>{item.title}</p>
								</div>
							)
						})}
					</div>
				</div>
			) : (null)}


			{globals.showDebugForComponents ? (
				<div style={{
					position: 'absolute',
					top: '50px',
					left: '50%',
					transform: 'translate (-50%, 0)',
					pointerEvents: 'all',
					zIndex: 100
				}}>
					<button tabIndex={-1} style={{
						color: 'white',
					}}onClick={() => {	
						globals.showDebugAnswerTypes = !globals.showDebugAnswerTypes;
						// props.forceUpdate();
					}}>
						{(globals.showDebugAnswerTypes ? 'Hide' : 'Show') + ' Answers'}
					</button>
				</div>
			) : (null)}

			{globals.showDebugForComponents ? (
				<div style={{
					position: 'absolute',
					bottom: '30px',
					left: '20px',
					pointerEvents: 'all',
					zIndex: 1000
				}}>
					<LoadedAssetsUI memory={globals.memory} assets={VideoEnvironment.videoAssets}></LoadedAssetsUI>
				</div>
			) : (null)}
		</div>
	);
};
export default DebugUI;

export interface DebugUIConfig {
	gameManager: GameManager;
	scenarioId: string;
}